module.exports = __webpack_public_path__ + "static/duerra-symbol-DND3_FnP-9b2d66ff26022be46c1afdf205a11ffe.webp";